import { render, staticRenderFns } from "./DashboardPage.html?vue&type=template&id=ad889742&scoped=true&"
import script from "./DashboardPage.ts?vue&type=script&lang=ts&"
export * from "./DashboardPage.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.scss?vue&type=style&index=0&id=ad889742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad889742",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VProgressLinear})
